
import React from 'react';
import { motion } from "framer-motion";

interface StepHeaderProps {
  icon: React.ReactNode;
  title: string;
}

export const StepHeader: React.FC<StepHeaderProps> = ({ icon, title }) => {
  return (
    <div className="flex flex-col items-center mb-6">
      {icon}
      <h3 className="text-2xl font-bold text-white mt-4">{title}</h3>
    </div>
  );
};
